import { ERROR_COLOR, GREY_600 } from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin, sizing } from "ds_legacy/materials/metrics";
import { Body, FONT_SIZE_16 } from "ds_legacy/materials/typography";
import { AlertTriangleIcon, LockIcon } from "lucide-react";
import { useTranslations } from "translations";

export const EncryptedHint = ({
  customMargin,
  isEncryptionActivated,
}: {
  customMargin?: string;
  isEncryptionActivated: boolean;
}) => {
  const translations = useTranslations();

  return (
    <HorizontalLayout aligned style={{ margin: customMargin }}>
      {isEncryptionActivated ? (
        <>
          <LockIcon
            size={FONT_SIZE_16}
            style={{
              color: GREY_600,
              fontSize: FONT_SIZE_16,
              margin: margin(0, 0, 0, 1),
            }}
          />
          <Body
            as="p"
            color={GREY_600}
            data-testid="encrypted-message-hint"
            lineHeight={sizing(2.5)}
            margin={margin(0, 1)}
            style={{ wordBreak: "break-word" }}
          >
            {translations.auctionResponse.sendEncryptedMessageHint}
          </Body>
        </>
      ) : (
        <>
          <AlertTriangleIcon
            size={16}
            style={{
              color: ERROR_COLOR,
              margin: margin(0, 0, 3, 0),
            }}
          />
          <Body
            as="p"
            lineHeight={sizing(2.5)}
            margin={margin(0, 1)}
            style={{ wordBreak: "break-word" }}
          >
            {translations.messenger.notEncryptedHint}
          </Body>
        </>
      )}
    </HorizontalLayout>
  );
};
